export default {
  path: 'winter-service/v2/book',
  name: 'WinterService2Book',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/BookIndex.vue')
}
